import { FC } from 'react';
import { Text, TextVariant } from 'components/_temp_ui_common/theme/Text';

interface LinksProps {
  url: string;
  target: string;
  text: string;
  textVariant: TextVariant;
  bold?: boolean;
}

const Links: FC<LinksProps> = ({ url, target, text, textVariant, bold }) => {
  return (
    <a
      href={url}
      target={target}
      className="font-semibold cursor-pointer text-[#018847] hover:underline"
      rel="noreferrer"
    >
      <Text bold={bold} variant={textVariant}>
        {text}
      </Text>
    </a>
  );
};

export default Links;
